<template>
  <div class="report">
     <v-container>
       <h2 class="title-color my-3">Reports</h2> 
       <v-card flat>
          <v-card-title>
          <v-toolbar flat color="white">
            <v-toolbar-title class="" style="color:#62AE32">Income Generated: <span class="font-weight-black black--text"><v-icon small color="black">mdi-currency-ngn</v-icon>{{Summary.premiumTotal}}</span></v-toolbar-title>
          </v-toolbar>
          <v-spacer></v-spacer>
          <v-toolbar flat color="white">
            <v-toolbar-title class="" style="color:#62AE32">Claims Paid: <span class="font-weight-black black--text"><v-icon small color="black">mdi-currency-ngn</v-icon>{{Summary.claimsTotal}}</span></v-toolbar-title>
          </v-toolbar>
          <v-spacer></v-spacer>
          <!-- <v-toolbar flat color="white">
            <v-toolbar-title class="" style="color:#62AE32">Outstanding Claims: <span class="font-weight-black black--text">#9</span></v-toolbar-title>
          </v-toolbar> -->
          <!-- <v-spacer></v-spacer> -->
          <v-toolbar flat color="white">
            <v-toolbar-title class="" style="color:#62AE32">Risk Covered: <span class="font-weight-black black--text"> <v-icon small color="black">mdi-currency-ngn</v-icon>{{Summary.riskCovered}}</span></v-toolbar-title>
          </v-toolbar>
          </v-card-title>
        </v-card>
       <v-tabs class="my-3" color="black" background-color="transparent">
           <v-tabs-slider color="#B45C5C"></v-tabs-slider>
        <v-tab>Table
        </v-tab>
         <v-tab>
             Graph
         </v-tab>

          

           <!-- second tab -->
         <v-tab-item>

    <!-- first report -->
         <v-card>
            <v-card-title>
                <v-toolbar flat color="white">
                <v-toolbar-title>Members: {{MembersCount}}</v-toolbar-title>
                 <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
              </v-toolbar>
              <v-spacer></v-spacer>
              <!-- start date for filtering -->
              <v-menu
                v-model="from"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="From"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="from = false"></v-date-picker>
              </v-menu>
              <v-spacer></v-spacer>
              <!-- End Date for filtering -->
              <v-menu
                v-model="to"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date2"
                    label="To"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" @input="to = false"></v-date-picker>
              </v-menu>
              <v-spacer></v-spacer>
              <v-select class="mt-3" label="Status" color="#08911B" :items="memberStatus" dense @change="MemberStatus($event)"></v-select>
              <v-spacer></v-spacer>
              <v-btn color="#B45C5C" :loading="loading" v-on:click="Filter()" class="white--text font-weigth-bold " style="font-size:14px">
                Go..
              </v-btn>
            </v-card-title>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="Members"
                :items-per-page="10"
                :single-select="singleSelect"
                item-key="Id"
                :search="search"
                class="elevation-1"
                no-data-text="No Members To Display"
                >
                </v-data-table>
                 <v-card-text class="text-right">
                  <VueJsonToCsv :json-data="Members" csv-title="Members_Report"  @success="val => handleSuccess(val)" @error="val => handleError(val)">
                    <v-btn flat class="white--text" color="#B45C5C">Download
                      <v-icon right>mdi-arrow-down</v-icon>
                    </v-btn>
                  </VueJsonToCsv>
                </v-card-text>
        </v-card>

        <!-- second report -->
        <v-card class="my-5">
            <v-card-title>
                <v-toolbar flat color="white">
                  <v-toolbar-title>No of cars Covered: {{CarsCount}}</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                </v-toolbar>
                  <v-spacer></v-spacer>
                  <!-- start date for filtering -->
                  <v-menu
                    v-model="fromCar"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateCar"
                        label="From"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dateCar" @input="fromCar = false"></v-date-picker>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <!-- End Date for filtering -->
                  <v-menu
                    v-model="toCar"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2Car"
                        label="To"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2Car" @input="toCar = false"></v-date-picker>
                  </v-menu>
                <v-spacer></v-spacer>
                <!-- <v-select class="mt-3" label="Status" color="#08911B" :items="carStatus" dense @change="CarStatus($event)"></v-select> -->
                <!-- <v-spacer></v-spacer> -->
                <v-btn color="#B45C5C" :loading="loadingCars" v-on:click="FilterCar()" class="white--text font-weigth-bold " style="font-size:14px">
                  Go..
                </v-btn>
            </v-card-title>
            <v-card-title class="mt-n9">
              <v-toolbar flat color="white">
                <v-toolbar-title>Amount Of Risk Covered: <span class="black--text font-weight-bold">&#8358;{{RiskCovered}}</span></v-toolbar-title>
              </v-toolbar>
            </v-card-title>
              <v-data-table
                    v-model="selected"
                    :headers="headers1"
                    :items="Cars"
                    :items-per-page="10"
                    :single-select="singleSelect"
                    item-key="name"
                    :search="search"
                    class="elevation-1"
                    no-data-text="No Cars To Display"
                >
                 </v-data-table>

                <v-card-text class="text-right">
                  <VueJsonToCsv :json-data="Cars" csv-title="Cars_Report" @success=" loading=false, val => handleSuccess(val)" @error="loading=false, val => handleError(val)">
                    <v-btn flat class="white--text" color="#B45C5C" :loading="loading">Download 
                      <v-icon right>mdi-arrow-down</v-icon>
                    </v-btn>
                  </VueJsonToCsv>
                </v-card-text>
        </v-card>
        
        <!-- third report: Transactions Report -->
        <v-card class="my-5">
          <v-card-title>
              <v-toolbar flat color="white">
                <v-toolbar-title>Transactions Total: <span class="font-weight-bold">&#8358;{{TransactionTotal}}</span></v-toolbar-title>
                  <v-divider
                  class="mx-4"
                  inset
                  vertical
                  ></v-divider>
              </v-toolbar>
                <v-spacer></v-spacer>
                <!-- start date for filtering -->
                <v-menu
                  v-model="fromTrans"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateTrans"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateTrans" @input="fromTrans = false"></v-date-picker>
                </v-menu>
                <v-spacer></v-spacer>
                <!-- End Date for filtering -->
                <v-menu
                  v-model="toTrans"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2Trans"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2Trans" @input="toTrans = false"></v-date-picker>
                </v-menu>
              <v-spacer></v-spacer>
              <v-select class="mt-3" label="Type" color="#08911B" style="width:10%" :items="transactionType" dense @change="TransactionType($event)"></v-select>
              <v-spacer></v-spacer>
              <v-btn color="#B45C5C" :loading="loadingTrans" v-on:click="FilterTrans()" class="white--text font-weigth-bold " style="font-size:14px">
                Go..
              </v-btn>
          </v-card-title>
          <v-card-title class="mt-n9">
            <v-toolbar flat color="white">
              <v-toolbar-title>Total Claims Paid: <span class="font-weight-bold">&#8358;{{ClaimsPaid}}</span></v-toolbar-title>
            </v-toolbar>
            <v-spacer></v-spacer>
            <v-toolbar flat color="white">
              <v-toolbar-title>Total Income Generated: <span class="font-weight-bold">&#8358;{{PremiumPaid}}</span></v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-data-table
            v-model="selected"
            :headers="headers2"
            :items="Transactions"
            :items-per-page="10"
            :single-select="singleSelect"
            item-key="TransactionId"
            :search="search"
            class="elevation-1"
            no-data-text="No Transactions To Display"
            >
            <template v-slot:item.Amount="{ item }">
             <span>&#8358;{{item.Amount}}</span>
            </template>
          </v-data-table>

          <v-card-text class="text-right">
            <VueJsonToCsv :json-data="Transactions" csv-title="Transactions_Report" @success=" loading=false, val => handleSuccess(val)" @error="loading=false, val => handleError(val)">
              <v-btn flat class="white--text" color="#B45C5C" :loading="loading">Download 
                <v-icon right>mdi-arrow-down</v-icon>
              </v-btn>
            </VueJsonToCsv>
          </v-card-text>
        </v-card>
         </v-tab-item>
          <!-- first tab -->
         <v-tab-item> 
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12">
              <iframe width="1000" height="500" class="hidden-sm-and-down" src="http://app.powerbi.com/view?r=eyJrIjoiOWRhMmYyYzYtYzVjNi00N2YxLTk2NjUtNWFlZDZmZDY0YjhjIiwidCI6ImYyMDk1NjNkLTFkYzgtNGQ1OS1iZThmLTkzN2JmMDRkMTJmOCJ9" frameborder="0" allowFullScreen=""></iframe>
             </v-col>
          </v-row> -->
          <v-row class="pa-3">
            <v-col cols="12" sm="12" md="4">
              <v-subheader v-if="loaded" class="font-weight-black">Total Members By Year</v-subheader>
              <BarChart v-if="loaded" :data="visitors" :styles="styles"/>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-subheader v-if="loadedPie" class="font-weight-black">Count Of Cars By Status</v-subheader>
              <PieChart v-if="loadedPie" :data="carsByStatus" :styles="styles"/>
            </v-col>
            <v-col cols="12" sm="12" md="4" class="mx-auto">
              <v-container fluid class="fill-height">
                <v-row justify-center align="center" justify="center">
                <h1>{{carCount}}</h1>
                <div class="mt-12 ml-n12"><span class="ml-n10 black--text">Number Of Cars</span></div>
              </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="7" class="ma-4">
              <v-subheader v-if="loadedLine" class="font-weight-bold">Transaction for Year {{year}}</v-subheader>
              <LineChart v-if="loadedLine" :data="transactionsLine" :styles="styles"/>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12">
          <iframe width="380" height="250" class="hidden-md-and-up" src="https://app.powerbi.com/view?r=eyJrIjoiOWRhMmYyYzYtYzVjNi00N2YxLTk2NjUtNWFlZDZmZDY0YjhjIiwidCI6ImYyMDk1NjNkLTFkYzgtNGQ1OS1iZThmLTkzN2JmMDRkMTJmOCJ9" frameborder="0" allowFullScreen=""></iframe>
             </v-col>
          </v-row> -->
         </v-tab-item>

         </v-tabs>
   
     </v-container>
  </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
import BarChart from '../components/Barchart'
import PieChart from '../components/PieChart' 
import LineChart from '../components/LineChart'
export default {
  components: {
    VueJsonToCsv,
    BarChart,
    PieChart,
    LineChart
  },
  data(){
    return{
      search: '',
      startDate: '',
      loadingCars:false,
      endDate: '',
      loading:false,
      loadingTrans:false,
      date: '',
      dateCar: '',
      dateTrans: '',
      date2: '',
      date2Car: '',
      date2Trans: '',
      from: false,
      fromCar: false,
      fromTrans: false,
      to: false,
      toCar: false,
      toTrans:false,
      memberStatus:["Verified", "Not Verified", "All"],
      carStatus:["Verified", "Not Verified", "All"],
      transactionType:['Claims', 'Premium', 'All'],
      memberClass:'',
      transType:'',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        { text: "Email", value: 'Email' },
        { text: 'Community', value: 'Community' },
        { text: 'Phone Number', value: 'Contact', sortable: false },
      ],
      headers1: [
        {
          text: 'Vehicle Make',
          align: 'left',
          sortable: false,
          value: 'VehicleMake',
        },
        { text: 'Reg No', value: 'RegistrationNumber' },
        { text: 'Color', value: 'Color' },
        { text: 'Engine No', value: 'EngineNumber'},
        { text: 'VIN', value: 'VIN'},
      ],
      headers2: [
        {
          text: 'Transaction Id',
          align: 'left',
          sortable: false,
          value: 'TransactionId',
        },
        { text: 'Depositor', value: 'Depositor' },
        { text: 'Recipient', value: 'Recipient' },
        { text: 'Amount', value: 'Amount'},
        { text: 'Date Paid', value: 'DatePaid'},
      ],
      visitors: null,
      carsByStatus: null,
      lineProps: null,
      styles: {
        position: "relative",
        height: "300px"
      },
      loaded:false,
      loadedPie:false,
      loadedLine:false,
      transactionsLine:null,
      carCount:0,
      year:new Date().getFullYear(),
          
    }
  },
  methods: {
    Yes(){
      alert(this.startDate);
      //eslint-disable-next-line no-console
      console.log(this.startDate);
    },
    MemberStatus(event){
      this.memberClass = event
    },
    CarStatus(event){
      this.carStatus = event
    },
    TransactionType(event){
      this.transType = event
    },
    Filter(){
      this.loading=true
      // check if from is smaller than to
      if(this.memberClass==="" || this.memberClass==="All"){
        this.$store.dispatch("getMembersReportFilter", {"from":this.date, "to":this.date2})
        .then((success)=>{
          this.loading=false
          console.log(success);
        })
        .catch((error)=>{
          this.loading=false
          console.log(error);
        });

      }else{
        this.$store.dispatch("getMembersReportFilter", {"from":this.date, "to":this.date2, "status":this.memberClass})
        .then((success)=>{
          this.loading=false
          console.log(success);
        })
        .catch((error)=>{
          this.loading=false
          console.log(error);
        });

      }
      
    },
    FilterCar(){
      this.loadingCars=true
      this.$store.dispatch("getCarsReportFilter", {"from":this.dateCar, "to":this.date2Car, 'status':'Paid', 'isExpired':0})
        .then((success)=>{
          this.loadingCars=false
          console.log(success);
        })
        .catch((error)=>{
          this.loadingCars=false
          console.log(error);
        });
    },
    FilterTrans(){
      this.loadingTrans= true
      if(this.transType==='All'|| this.transType===''){
        this.$store.dispatch("getTransactionFilter", {"from":this.dateTrans, "to":this.date2Trans, "status":'Successful'})
        .then((success)=>{
          this.loadingTrans=false
          console.log(success);
        })
        .catch((error)=>{
          this.loadingTrans=false
          console.log(error);
        });
      }else{
        if(this.transType==='Premium'){this.transType='premium'}
        this.$store.dispatch("getTransactionFilter", {"from":this.dateTrans, "to":this.date2Trans, "status":'Successful', 'type':this.transType})
        .then((success)=>{
          this.loadingTrans=false
          console.log(success);
        })
        .catch((error)=>{
          this.loadingTrans=false
          console.log(error);
        });
      }
    }
  },
  computed:{
    Members(){
      return this.$store.state.reports.NumberOfMembers.members
    },
    Summary(){
      let trans= this.$store.state.reports.SummaryReport
      trans.claimsTotal= parseFloat(trans.claimsTotal).toFixed(2)
      trans.claimsTotal= trans.claimsTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      trans.premiumTotal= parseFloat(trans.premiumTotal).toFixed(2)
      trans.premiumTotal= trans.premiumTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      trans.riskCovered= parseFloat(trans.riskCovered).toFixed(2)
      trans.riskCovered= trans.riskCovered.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      return trans
    },
    MembersCount(){
      return this.$store.state.reports.NumberOfMembers.count
    },
    Cars(){
      return this.$store.state.reports.NumberOfCars.vehicles
    },
    CarsCount(){
      return this.$store.state.reports.NumberOfCars.count
    },
    RiskCovered(){
      let trans = this.$store.state.reports.NumberOfCars.riskCovered
      trans = parseFloat(trans).toFixed(2)
      trans = trans.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      return trans
    },
    Transactions(){
      let trans = this.$store.state.reports.Transactions.transactions
      for(let j=0; j<trans.length; j++){
        trans[j].Amount = parseFloat(trans[j].Amount).toFixed(2)
        trans[j].Amount = trans[j].Amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        
        trans[j].DatePaid= trans[j].DatePaid.slice(0, 19).replace('T', ' ');
      }
      return trans
    }, 
    TransactionTotal(){
      let trans= this.$store.state.reports.Transactions.sum
      trans= parseFloat(trans).toFixed(2)
      trans= trans.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      
      return trans

    },
    ClaimsPaid(){
      let trans= this.$store.state.reports.Transactions.claimsTotal
      trans = parseFloat(trans).toFixed(2)
      trans = trans.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      
      return trans
    },
    PremiumPaid(){
      let trans= this.$store.state.reports.Transactions.premiumTotal
      trans = parseFloat(trans).toFixed(2)
      trans = trans.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      
      return trans
    },
    MemberYearlyReport(){
      let result= this.$store.state.reports.MemberYearlyReport

    }
  },
  async created(){
    this.$store.dispatch("getMembersReport")
    .then((success)=>{
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    // get cars
    this.$store.dispatch("getCarsReport", {'status':'Paid', 'isExpired':0})
    .then((success)=>{
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    // get Transactions
    this.$store.dispatch("getTransactions", {"status":'Successful'})
    .then((success)=>{
      this.loadingTrans=false
      console.log(success);
    })
    .catch((error)=>{
      this.loadingTrans=false
      console.log(error);
    });
    // get members yearly report
    this.$store.dispatch("getMembersYearlyReport")
    .then((success)=>{
      this.loaded = true
      this.visitors = success;
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    // get cars report by status
    this.$store.dispatch("getCarsByStatus")
    .then((success)=>{
      this.loadedPie = true
      this.carsByStatus = success;
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });

    this.$store.dispatch("getSummary")
    .then((success)=>{
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    this.$store.dispatch("getCarsCount")
    .then((success)=>{
      this.carCount= success.count
    })
    .catch((error)=>{
      console.log(error);
    });
    // claims amount paid for the year with months
    this.$store.dispatch("getClaimsAmountWithMonths")
    .then((success)=>{
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    // premium amount paid for the year with months
    this.$store.dispatch("getPremiumAmountWithMonths")
    .then((success)=>{
      console.log(success);
    })
    .catch((error)=>{
      console.log(error);
    });
    const results=  this.$store.state.reports.ClaimMonthsAmount.claimMonth
    const result2= this.$store.state.reports.PremiumMonthsAmount.premiumMonth
    let arr=[]
    arr[0]=results
    arr[1]=result2
    console.log('====================arr herer ==========================')

    this.transactionsLine=arr
    console.log(this.tansactionLine)
    this.loadedLine=true
  }
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.report{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
</style>
